/**
 * Дверь на 2D-чертеже. Как рисовать, решает тип двери из каталога: распашная —
 * полотно и дуга открывания (`SwingDoorShape`), раздвижная — полотно вдоль стены
 * (`SlidingDoorShape`).
 */
import type { PointerEvent } from "react";
import { DoorMechanism, doorItemOf } from "@/shared/catalog";
import type { Opening } from "@/shared/plan";
import { SlidingDoorShape } from "./SlidingDoorShape";
import { SwingDoorShape } from "./SwingDoorShape";

export interface OpeningShapeProps {
	opening: Opening;
	/** Толщина стены, в которой сидит проём, мм */
	wallThickness: number;
	selected: boolean;
	/** Размер миллиметра в пикселях — для линий постоянной толщины на экране */
	mmPerPx: number;
	interactive: boolean;
	onPointerDown: (e: PointerEvent<SVGRectElement>) => void;
}

export const DoorShape = (props: OpeningShapeProps) =>
	doorItemOf(props.opening.item).mechanism === DoorMechanism.Sliding ? (
		<SlidingDoorShape {...props} />
	) : (
		<SwingDoorShape {...props} />
	);
